import SelectButtons from "./SelectButtons";
import classNames from "classnames";
import React, {Fragment} from "react";
import SelectNormal from "./SelectNormal";
import MainButton from "../forms/Buttons";

class SelectButtonsWithMore extends SelectButtons {
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            value: undefined,
            containerWidth: 0,
            collapsedButtonWidth: 0,
            visibleButtonWidth: 0,
        };


        this.visibleButtonRef = React.createRef();
        this.collapsedButtonRef = React.createRef();
        this.containerRef = React.createRef();
    }

    render = () => {
        const {split} = this.props;
        const componentClassName = this.getComponentClassName();
        const colorClassName = this.getColorClassName();

        return (
            <div ref={this.containerRef} className={classNames("select-buttons", componentClassName, colorClassName, {"select-buttons-split": split})}>
                {this.renderOptions()}
            </div>
        );
    };

    renderOptions = () => {
        return (
            <Fragment>
                {this.renderVisibleOptions()}
                {this.renderCollapsedOptions()}
            </Fragment>
        );
    };

    renderVisibleOptions = () => {
        const {options} = this.props;
        const limit = this.getLimit();

        const visibleOptions = options.slice(0, limit);
        return visibleOptions.map(this.renderOption)
    };

    renderOption = (option, index) => {
        const {value} = this.state;
        const {size} = this.props;
        const color = option.value === value ? "toggleActive" : "toggleInactive";

        return (
            <MainButton ref={this.visibleButtonRef} size={size} color={color} key={index} text={option.label} onClick={(event) => this.handleSelect(event, option)}/>
        );
    };

    renderCollapsedOptions = () => {
        const {options, size} = this.props;
        const limit = this.getLimit();

        if (limit < options.length) {
            const {value} = this.state;
            const collapsedOptions = options.slice(limit);
            const color = collapsedOptions.filter(option => option.value === value).length !== 0 ? "toggle-active" : "toggle-inactive";

            return (
                <SelectNormal ref={this.collapsedButtonRef} color={color} type={size} options={collapsedOptions} defaultValue={collapsedOptions[0]} onChange={(option) => this.handleSelect(null, option)}/>
            );
        }
    };


    // TODO: Calculate limit auto.
    getLimit = () => {
        const {limit} = this.props;
        if (limit === 'auto') {
            throw new Error("'Auto' options is not implemented yet");
            // const visibleButtonWidth = 60;
            // const collapsedButtonWidth = 85;
            // // const visibleButtonWidth = this.visibleButtonRef?.current?.offsetWidth;
            // // const collapsedButtonWidth = this.collapsedButtonRef?.current?.offsetWidth;
            // const containerWidth = this.containerRef?.current?.offsetWidth;
            //
            // return this.calculateLimit(visibleButtonWidth, collapsedButtonWidth, containerWidth);
        } else {
            return limit;
        }
    };

    calculateLimit = (visibleButtonWidth, collapsedButtonWidth, containerWidth) => {
        console.log((containerWidth - collapsedButtonWidth) / visibleButtonWidth);
        return 2;
    };
}

export default SelectButtonsWithMore;
